var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_3777",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_3777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_2",
    d: "M4.125 17.4168V9.30773C4.125 9.04541 4.18367 8.79691 4.301 8.56225C4.41849 8.32743 4.58074 8.13409 4.78775 7.98223L10.0059 4.0511C10.2954 3.83019 10.6263 3.71973 10.9986 3.71973C11.3709 3.71973 11.7028 3.83019 11.9941 4.0511L17.2123 7.98223C17.4193 8.13409 17.5815 8.32743 17.699 8.56225C17.8163 8.79691 17.875 9.04541 17.875 9.30773V17.4168C17.875 17.7917 17.7396 18.1146 17.4687 18.3855C17.1978 18.6564 16.8749 18.7918 16.5 18.7918H13.5738C13.339 18.7918 13.1422 18.7123 12.9834 18.5535C12.8245 18.3947 12.7451 18.1979 12.7451 17.9631V13.4857C12.7451 13.251 12.6657 13.0542 12.507 12.8953C12.3483 12.7366 12.1515 12.6572 11.9167 12.6572H10.0833C9.84851 12.6572 9.65174 12.7366 9.493 12.8953C9.33426 13.0542 9.2549 13.251 9.2549 13.4857V17.9631C9.2549 18.1979 9.17545 18.3947 9.01656 18.5535C8.85783 18.7123 8.66105 18.7918 8.42623 18.7918H5.5C5.12508 18.7918 4.80219 18.6564 4.53131 18.3855C4.26044 18.1146 4.125 17.7917 4.125 17.4168Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.ea8d1f7e265e8f90f14cbd6f97ee55f8.svg";
export { ForwardRef as ReactComponent };